import UserSpecializationSelect from './UserSpecializationSelect';
import UserTeamCreatableSelect from './UserTeamCreatableSelect';
import type { UserTabProps } from '../../types';

const UserTabAccessExecutor = ({ user, dispatchUser }: UserTabProps) => {
    return (
        <>
            <UserTeamCreatableSelect user={user} dispatchUser={dispatchUser} />
            <UserSpecializationSelect user={user} dispatchUser={dispatchUser} />
        </>
    );
};

export default UserTabAccessExecutor;
